module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/31bc215b68328a5bbadf9e542ab8e90b.png";